module.exports = function () {
  return new Worker(__webpack_public_path__ + "c080ebd8fc83858c7765.worker.js");
};